import {
  SkeletonLoader,
  SkeletonLoaderProps,
} from '@kanda-libs/ks-design-library';
import { ReactNode, useMemo } from 'react';

export interface InfoPillProps {
  content: ReactNode;
  id: string;
  active?: boolean;
  onClick?: () => void;
  isLoading?: boolean;
  skeletonProps?: SkeletonLoaderProps;
}

const InfoPill: React.FunctionComponent<InfoPillProps> = function ({
  content,
  id,
  active = false,
  onClick,
  isLoading = false,
  skeletonProps,
}) {
  const className = useMemo(
    () =>
      [
        'py-1.5 px-3 rounded-full border text-13-14',
        onClick && !isLoading ? 'cursor-pointer' : 'cursor-default',
        active
          ? 'border-neutral-900 bg-neutral-900 text-neutral-000'
          : 'border-neutral-400 bg-neutral-000 text-neutral-900',
      ].join(' '),
    [active, isLoading, onClick],
  );

  const finalSkeletonProps = useMemo(
    () => ({
      width: 80,
      height: 28,
      ...skeletonProps,
    }),
    [skeletonProps],
  );

  return (
    <SkeletonLoader
      isLoading={isLoading}
      {...finalSkeletonProps}
      afterLoading={
        <button id={id} className={className} onClick={onClick} type="button">
          {content}
        </button>
      }
    />
  );
};

export default InfoPill;
